module.exports = __webpack_public_path__ + "img/flow-09.9eca35dd.png";